/* Local dependencies */
import { Warehouse, WarehouseStatus } from '../../types';

export enum UpdateWarehouseActionTypes {
  UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE',
  UPDATE_WAREHOUSE_SUCCESS = 'UPDATE_WAREHOUSE_SUCCESS',
  UPDATE_WAREHOUSE_ERROR = 'UPDATE_WAREHOUSE_ERROR',
  UPDATE_WAREHOUSE_RESET_ERROR = 'UPDATE_WAREHOUSE_RESET_ERROR',
  UPDATE_WAREHOUSE_RESET_STATE = 'UPDATE_WAREHOUSE_RESET_STATE',
}

export interface UpdateWarehouseInput {
  id: string;
  address: string;
  city: string;
  region: string;
  country: string;
  postcode: string;
  phone: string;
  status: WarehouseStatus;
}

export interface UpdateWarehouseRequest {
  type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE;
  input: UpdateWarehouseInput;
}

export interface UpdateWarehouseSuccess {
  type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_SUCCESS;
  warehouse: Warehouse;
}

export interface UpdateWarehouseError {
  type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_ERROR;
  error: Error;
}

export interface ResetUpdateWarehouseError {
  type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_ERROR;
}

export interface ResetUpdateWarehouseState {
  type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_STATE;
}

export type UpdateWarehouseAction =
  | UpdateWarehouseRequest
  | UpdateWarehouseSuccess
  | UpdateWarehouseError
  | ResetUpdateWarehouseError
  | ResetUpdateWarehouseState;
